// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumb_root__ve5jt","list":"breadcrumb_list__Srpth","ancestorBtn":"breadcrumb_ancestorBtn__stM49"};